import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wp1200 withPadding top0" }
const _hoisted_2 = { class: "findPath" }
const _hoisted_3 = { class: "inputWrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_start icon left" }, null, -1)
const _hoisted_5 = { class: "inputWrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_finish icon left" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_CustomButton = _resolveComponent("CustomButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, [
          _createVNode(_component_GMapAutocomplete, {
            onChange: _ctx.onOriginChange,
            onPlace_changed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.origin = $event.formatted_address)),
            placeholder: _ctx.$t('find_path.enter_start'),
            options: {
              componentRestrictions: { country: 'si' },
            }
          }, null, 8, ["onChange", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, [
          _createVNode(_component_GMapAutocomplete, {
            onChange: _ctx.onDestinationChange,
            onPlace_changed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.destination = $event.formatted_address)),
            placeholder: _ctx.$t('find_path.enter_stop'),
            options: {
              componentRestrictions: { country: 'si' },
            }
          }, null, 8, ["onChange", "placeholder"])
        ])
      ]),
      _createVNode(_component_CustomButton, {
        "event-name": "routeSearchButton",
        "event-from": "/public-transport/find-path",
        label: _ctx.$t('find_path.search'),
        "add-class": "findPathButton",
        onClick: _ctx.search
      }, null, 8, ["label", "onClick"])
    ])
  ]))
}